// extracted by mini-css-extract-plugin
export default {"callback__loading-container":"callback_callback__loading-container__SXpLC"};